export enum DirectionType {
  Row,
  Column,
}
